import {createAction} from '@reduxjs/toolkit';
import {updatePostDto, getPubPostsDto} from 'typescript/dto/postsDto';
import {IPost} from 'typescript/models/Post';
import {withPayloadType} from 'typescript/types/PayloadType';

import postArchiveSlice from './postArchiveSlice';

export const addPostToFavoritesACS = createAction(
  `${postArchiveSlice.name}/addPostToFavoritesACS`,
  withPayloadType<{id: IPost['id']; favorite: updatePostDto['favorite']; getPubPostsDto: getPubPostsDto}>(),
);
